// utils
import axios from "src/utils/axios";
import apiSlice from "src/utils/api-slice";
import { setURLParams } from "src/utils/url-query";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    getTransaction: "/transaction_record/search",
};

// ----------------------------------------------------------------------

const {
    useGetTransactionListQuery
} = apiSlice.injectEndpoints({
    endpoints: builder => ( {
        getTransactionList: builder.query({
            keepUnusedDataFor: 5,
            providesTags: [ "TransactionList" ],
            query: (request) => `${ API_ENDPOINTS.getTransaction }${ setURLParams(request) }`,
            transformResponse: ({ data }, meta, arg) => data
        })
    } ),
    overrideExisting: true
});

// ----------------------------------------------------------------------

export {
    useGetTransactionListQuery,
};
